module.exports = __webpack_public_path__ + "static/media/entertainer_artist.3511b7ca.webp";